import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconFilterAltSvg } from "./IconFilterAltSvg.mjs";
const IconFilterAlt = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconFilterAltSvg, ...iconProps });
};
export {
  IconFilterAlt
};
